export const CLIENT_ID = '252122378385-p7dl7manqbv60inb2av1f89uf50uoocq.apps.googleusercontent.com';
export const REDIRECT_URI = 'http://localhost:3000/oauth-callback';
export const BACKEND_URL = 'http://localhost:5000'; // if your backend is running on port 5000
